var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return JSON.stringify(_vm.datas) !== "{}"
    ? _c("div", { staticClass: "costBox" }, [
        _vm.state == 3 || _vm.state == 5 || _vm.state == 9
          ? _c(
              "div",
              [
                _vm._l(_vm.costObj[_vm.state], function (item, index) {
                  return _c(
                    "div",
                    { key: index + "costObj", staticClass: "column" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "columnText2",
                          staticStyle: { width: "1.4rem" },
                        },
                        [_vm._v(" " + _vm._s(item.title) + " ")]
                      ),
                      _c("el-input", {
                        staticClass: "columnText3",
                        staticStyle: { flex: "1", "padding-left": "20rpx" },
                        attrs: {
                          disabled: _vm.disabled,
                          size: "small",
                          value: _vm.datas.otherStockData[item.code],
                          "placeholder-class": "placeholder",
                          placeholder: item.placeholder,
                          type: "text",
                        },
                      }),
                    ],
                    1
                  )
                }),
                _vm.state == 9
                  ? _c("div", { staticClass: "column" }, [
                      _c("div", { staticClass: "columnText4" }, [
                        _vm._v(" 哪些费用需要单独支付 "),
                      ]),
                    ])
                  : _vm._e(),
                _vm._l(_vm.costObj1[_vm.state], function (item, index) {
                  return _c(
                    "div",
                    { key: index + "costObj1", staticClass: "column" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "columnText2",
                          staticStyle: {
                            width: "0.9rem",
                            "text-align": "left",
                          },
                        },
                        [_vm._v(" " + _vm._s(item.title) + " ")]
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                            "margin-right": "0.25rem",
                          },
                        },
                        [
                          _c(
                            "el-radio",
                            {
                              attrs: {
                                disabled: _vm.disabled,
                                size: "medium",
                                label: 0,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handlerSelectClick(1)
                                },
                              },
                              model: {
                                value: _vm.datas.otherStockData[item.code1],
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.datas.otherStockData,
                                    item.code1,
                                    $$v
                                  )
                                },
                                expression: "datas.otherStockData[item.code1]",
                              },
                            },
                            [_vm._v(" ")]
                          ),
                          _c("span", { staticClass: "columnText2" }, [
                            _vm._v(_vm._s(item.text[0])),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                            "margin-right": "0.2rem",
                          },
                        },
                        [
                          _c(
                            "el-radio",
                            {
                              attrs: {
                                disabled: _vm.disabled,
                                size: "medium",
                                label: 1,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handlerSelectClick(1)
                                },
                              },
                              model: {
                                value: _vm.datas.otherStockData[item.code1],
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.datas.otherStockData,
                                    item.code1,
                                    $$v
                                  )
                                },
                                expression: "datas.otherStockData[item.code1]",
                              },
                            },
                            [_vm._v(" ")]
                          ),
                          _c("span", { staticClass: "columnText2" }, [
                            _vm._v(_vm._s(item.text[1])),
                          ]),
                        ],
                        1
                      ),
                      _c("el-input", {
                        staticClass: "columnText3",
                        staticStyle: { flex: "1" },
                        attrs: {
                          disabled: _vm.disabled,
                          size: "small",
                          value: _vm.datas.otherStockData[item.code],
                          "placeholder-class": "placeholder",
                          placeholder: item.placeholder,
                          type: "text",
                        },
                      }),
                    ],
                    1
                  )
                }),
                _vm._m(0),
              ],
              2
            )
          : _vm._e(),
        _c("div", { staticClass: "column" }, [
          _c("div", { staticClass: "columnText2" }, [
            _vm._v(" 是否含commission "),
          ]),
          _c(
            "div",
            {
              staticClass: "columnText3",
              staticStyle: { "text-align": "center", flex: "1" },
            },
            [
              _vm._v(
                _vm._s(
                  _vm.datas.isCommission != null &&
                    _vm.datas.isCommission != undefined
                    ? _vm.isVatList[_vm.datas.isCommission]
                    : "未填写"
                )
              ),
            ]
          ),
          _vm.datas.isCommission == 1
            ? _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "align-items": "center",
                    width: "2.6rem",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "columnText2",
                      staticStyle: { "margin-right": "0.1rem" },
                    },
                    [
                      _vm._v(
                        " commission金额：" +
                          _vm._s(
                            _vm.datas.vatPrice ? _vm.datas.vatPrice : "未填写"
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c("div", { staticClass: "columnText2" }, [
                    _vm._v(" 币种："),
                    _c("span", { staticClass: "columnText3" }, [
                      _vm._v(
                        _vm._s(
                          _vm.datas.prices[0].currency
                            ? _vm.datas.prices[0].currency
                            : "未填写"
                        )
                      ),
                    ]),
                  ]),
                ]
              )
            : _vm._e(),
        ]),
        _c("div", { staticClass: "column" }, [
          _c("div", { staticClass: "columnText2" }, [_vm._v(" 是否含VAT ")]),
          _c(
            "div",
            {
              staticClass: "columnText3",
              staticStyle: { flex: "1", "text-align": "center" },
            },
            [
              _vm._v(
                _vm._s(
                  _vm.datas.isVat != null && _vm.datas.isVat != undefined
                    ? _vm.isVatList[_vm.datas.isVat]
                    : "未填写"
                )
              ),
            ]
          ),
          _vm.datas.isVat == 1
            ? _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "align-items": "center",
                    flex: "1",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "columnText2",
                      staticStyle: { "margin-right": "0.1rem" },
                    },
                    [
                      _vm._v(
                        " VAT金额：" +
                          _vm._s(
                            _vm.datas.vatPrice ? _vm.datas.vatPrice : "未填写"
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c("div", { staticClass: "columnText2" }, [
                    _vm._v(" 币种："),
                    _c("span", { staticClass: "columnText3" }, [
                      _vm._v(
                        _vm._s(
                          _vm.datas.prices[0].currency
                            ? _vm.datas.prices[0].currency
                            : "未填写"
                        )
                      ),
                    ]),
                  ]),
                ]
              )
            : _vm._e(),
        ]),
        _c("div", { staticClass: "column" }, [
          _c("div", { staticClass: "columnText2" }, [_vm._v(" 是否含城市税 ")]),
          _c("div", { staticStyle: { flex: "1", "text-align": "center" } }, [
            _c(
              "div",
              { staticClass: "columnText3", staticStyle: { flex: "1" } },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.datas.isCityTax != null &&
                        _vm.datas.isCityTax != undefined
                        ? _vm.isTaxList[_vm.datas.isCityTax]
                        : "未填写"
                    ) +
                    " "
                ),
              ]
            ),
          ]),
          _vm.datas.isCityTax == 1
            ? _c(
                "div",
                {
                  staticStyle: {
                    flex: "1",
                    display: "flex",
                    "align-items": "center",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "columnText2",
                      staticStyle: { "margin-right": "0.1rem" },
                    },
                    [
                      _vm._v(
                        " 城市税金：" +
                          _vm._s(
                            _vm.datas.cityTaxPrice
                              ? _vm.datas.cityTaxPrice
                              : "未填写"
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c("div", { staticClass: "columnText2" }, [
                    _vm._v(" 币种："),
                    _c("span", { staticClass: "columnText3" }, [
                      _vm._v(
                        _vm._s(
                          _vm.datas.prices[0].currency
                            ? _vm.datas.prices[0].currency
                            : "未填写"
                        )
                      ),
                    ]),
                  ]),
                ]
              )
            : _vm._e(),
        ]),
        _vm.state == 0
          ? _c("div", { staticClass: "column" }, [
              _c("div", { staticClass: "columnText2" }, [
                _vm._v(" 报价含早餐 "),
              ]),
              _c(
                "div",
                {
                  staticClass: "columnText3",
                  staticStyle: { flex: "1", "text-align": "center" },
                },
                [
                  _c("span", { staticClass: "columnText2" }, [
                    _vm._v("早餐数量："),
                  ]),
                  _vm._v(
                    _vm._s(
                      _vm.datas.otherStockData.breakfastNum
                        ? _vm.datas.otherStockData.breakfastNum
                        : 0
                    ) + " "
                  ),
                  _c("span", { staticClass: "columnText2" }, [_vm._v("份")]),
                ]
              ),
              _c(
                "div",
                { staticClass: "columnText3", staticStyle: { flex: "1" } },
                [
                  _c("span", { staticClass: "columnText2" }, [
                    _vm._v("备注："),
                  ]),
                  _vm._v(
                    _vm._s(
                      _vm.datas.otherStockData.breakfastRemark
                        ? _vm.datas.otherStockData.breakfastRemark
                        : "未填写"
                    ) + " "
                  ),
                ]
              ),
            ])
          : _vm._e(),
        _c(
          "div",
          [
            _vm._m(1),
            _vm._l(_vm.datas.contains[2], function (item, index) {
              return _c("div", { key: index + "contains2" }, [
                _c(
                  "div",
                  { staticClass: "column" },
                  [
                    _c("div", { staticClass: "columnText5" }, [
                      _vm._v(" 设施名称 "),
                    ]),
                    _c("el-input", {
                      staticClass: "columnText3",
                      staticStyle: { width: "3rem" },
                      attrs: {
                        disabled: _vm.disabled,
                        size: "small",
                        placeholder: "请点击输入设施名称",
                        type: "text",
                      },
                      model: {
                        value: item.name,
                        callback: function ($$v) {
                          _vm.$set(item, "name", $$v)
                        },
                        expression: "item.name",
                      },
                    }),
                    _c("el-input", {
                      staticClass: "columnText3",
                      staticStyle: { width: "0.7rem" },
                      attrs: {
                        disabled: _vm.disabled,
                        size: "small",
                        placeholder: "0",
                        type: "text",
                      },
                      model: {
                        value: item.number,
                        callback: function ($$v) {
                          _vm.$set(item, "number", $$v)
                        },
                        expression: "item.number",
                      },
                    }),
                    _c("span", { staticClass: "columnText2" }, [_vm._v("份")]),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "column" },
                  [
                    _c("div", { staticClass: "columnText2" }, [
                      _vm._v(" 设施备注 "),
                    ]),
                    _c("el-input", {
                      staticClass: "columnText3",
                      staticStyle: { width: "4.12rem" },
                      attrs: {
                        disabled: _vm.disabled,
                        size: "small",
                        placeholder: "请填写设施材质尺寸等描述",
                        type: "text",
                      },
                      model: {
                        value: item.containDescribe,
                        callback: function ($$v) {
                          _vm.$set(item, "containDescribe", $$v)
                        },
                        expression: "item.containDescribe",
                      },
                    }),
                  ],
                  1
                ),
              ])
            }),
            _vm._l(_vm.datas.contains[1], function (item, index) {
              return _c("div", { key: index + "contains1" }, [
                _c(
                  "div",
                  {
                    staticClass: "column",
                    style: [
                      index == 0 ? { borderTop: "1px dotted #496878" } : "",
                    ],
                  },
                  [
                    _c("div", { staticClass: "columnText5" }, [
                      _vm._v(" 服务名称 "),
                    ]),
                    _c("el-input", {
                      staticClass: "columnText3",
                      staticStyle: { width: "3rem" },
                      attrs: {
                        disabled: _vm.disabled,
                        size: "small",
                        placeholder: "请点击输入服务名称",
                        type: "text",
                      },
                      model: {
                        value: item.name,
                        callback: function ($$v) {
                          _vm.$set(item, "name", $$v)
                        },
                        expression: "item.name",
                      },
                    }),
                    _c("el-input", {
                      staticClass: "columnText3",
                      staticStyle: { width: "0.7rem" },
                      attrs: {
                        disabled: _vm.disabled,
                        size: "small",
                        placeholder: "0",
                        type: "text",
                      },
                      model: {
                        value: item.number,
                        callback: function ($$v) {
                          _vm.$set(item, "number", $$v)
                        },
                        expression: "item.number",
                      },
                    }),
                    _c("span", { staticClass: "columnText2" }, [_vm._v("份")]),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "column" },
                  [
                    _c("div", { staticClass: "columnText2" }, [
                      _vm._v(" 服务备注 "),
                    ]),
                    _c("el-input", {
                      staticClass: "columnText3",
                      staticStyle: { width: "4.12rem" },
                      attrs: {
                        disabled: _vm.disabled,
                        size: "small",
                        placeholder: "请填写服务标准等描述",
                        type: "text",
                      },
                      model: {
                        value: item.containDescribe,
                        callback: function ($$v) {
                          _vm.$set(item, "containDescribe", $$v)
                        },
                        expression: "item.containDescribe",
                      },
                    }),
                  ],
                  1
                ),
              ])
            }),
          ],
          2
        ),
        _c(
          "div",
          [
            _vm._m(2),
            _vm._l(_vm.datas.contains[4], function (item, index) {
              return _c("div", { key: index + "contains4" }, [
                _c(
                  "div",
                  { staticClass: "column" },
                  [
                    _c("div", { staticClass: "columnText5" }, [
                      _vm._v(" 设施名称 "),
                    ]),
                    _c("el-input", {
                      staticClass: "columnText3",
                      staticStyle: { width: "3rem" },
                      attrs: {
                        disabled: _vm.disabled,
                        size: "small",
                        placeholder: "请点击输入设施名称",
                        type: "text",
                      },
                      model: {
                        value: item.name,
                        callback: function ($$v) {
                          _vm.$set(item, "name", $$v)
                        },
                        expression: "item.name",
                      },
                    }),
                    _c("el-input", {
                      staticClass: "columnText3",
                      staticStyle: { width: "0.7rem" },
                      attrs: {
                        disabled: _vm.disabled,
                        size: "small",
                        placeholder: "0",
                        type: "text",
                      },
                      model: {
                        value: item.number,
                        callback: function ($$v) {
                          _vm.$set(item, "number", $$v)
                        },
                        expression: "item.number",
                      },
                    }),
                    _c("span", { staticClass: "columnText2" }, [_vm._v("份")]),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "column",
                    staticStyle: { "padding-right": "60rpx" },
                  },
                  [
                    _c("div", { staticClass: "columnText2" }, [
                      _vm._v(" 额外付费 "),
                    ]),
                    _c("el-input", {
                      staticClass: "columnText3",
                      staticStyle: { width: "1rem", "text-align": "center" },
                      attrs: {
                        disabled: _vm.disabled,
                        size: "small",
                        placeholder: "0",
                        type: "text",
                      },
                      model: {
                        value: item.price,
                        callback: function ($$v) {
                          _vm.$set(item, "price", $$v)
                        },
                        expression: "item.price",
                      },
                    }),
                    _c("span", { staticClass: "columnText2" }, [
                      _vm._v("货币"),
                    ]),
                    _c("div", { staticClass: "columnText3" }, [
                      _vm._v(
                        " " + _vm._s(item.currency ? item.currency : "¥") + " "
                      ),
                    ]),
                    _c("span", { staticClass: "columnText2" }, [_vm._v("/份")]),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "column" },
                  [
                    _c("div", { staticClass: "columnText2" }, [
                      _vm._v(" 设施备注 "),
                    ]),
                    _c("el-input", {
                      staticClass: "columnText3",
                      staticStyle: { width: "4.12rem" },
                      attrs: {
                        disabled: _vm.disabled,
                        size: "small",
                        placeholder: "请填写设施材质尺寸等描述",
                        type: "text",
                      },
                      model: {
                        value: item.containDescribe,
                        callback: function ($$v) {
                          _vm.$set(item, "containDescribe", $$v)
                        },
                        expression: "item.containDescribe",
                      },
                    }),
                  ],
                  1
                ),
              ])
            }),
            _vm._l(_vm.datas.contains[3], function (item, index) {
              return _c("div", { key: index + "contains3" }, [
                _c(
                  "div",
                  {
                    staticClass: "column",
                    style: [
                      index == 0 ? { borderTop: "1px dotted #496878" } : "",
                    ],
                  },
                  [
                    _c("div", { staticClass: "columnText5" }, [
                      _vm._v(" 服务名称 "),
                    ]),
                    _c("el-input", {
                      staticClass: "columnText3",
                      staticStyle: { width: "3rem" },
                      attrs: {
                        disabled: _vm.disabled,
                        size: "small",
                        placeholder: "请点击输入服务名称",
                        type: "text",
                      },
                      model: {
                        value: item.name,
                        callback: function ($$v) {
                          _vm.$set(item, "name", $$v)
                        },
                        expression: "item.name",
                      },
                    }),
                    _c("el-input", {
                      staticClass: "columnText3",
                      staticStyle: { width: "0.7rem" },
                      attrs: {
                        disabled: _vm.disabled,
                        size: "small",
                        placeholder: "0",
                        type: "text",
                      },
                      model: {
                        value: item.number,
                        callback: function ($$v) {
                          _vm.$set(item, "number", $$v)
                        },
                        expression: "item.number",
                      },
                    }),
                    _c("span", { staticClass: "columnText2" }, [_vm._v("份")]),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "column",
                    staticStyle: { "padding-right": "60rpx" },
                  },
                  [
                    _c("div", { staticClass: "columnText2" }, [
                      _vm._v(" 额外付费 "),
                    ]),
                    _c("el-input", {
                      staticClass: "columnText3",
                      staticStyle: { width: "1rem", "text-align": "center" },
                      attrs: {
                        disabled: _vm.disabled,
                        size: "small",
                        placeholder: "0",
                        type: "text",
                      },
                      model: {
                        value: item.price,
                        callback: function ($$v) {
                          _vm.$set(item, "price", $$v)
                        },
                        expression: "item.price",
                      },
                    }),
                    _c("span", { staticClass: "columnText2" }, [
                      _vm._v("货币"),
                    ]),
                    _c("el-input", {
                      staticClass: "columnText3",
                      staticStyle: { width: "1rem", "text-align": "center" },
                      attrs: {
                        disabled: _vm.disabled,
                        size: "small",
                        placeholder: "0",
                        type: "text",
                      },
                      model: {
                        value: item.price,
                        callback: function ($$v) {
                          _vm.$set(item, "price", $$v)
                        },
                        expression: "item.price",
                      },
                    }),
                    _c("span", { staticClass: "columnText2" }, [
                      _vm._v("货币"),
                    ]),
                    _c("div", { staticClass: "columnText3" }, [
                      _vm._v(
                        " " + _vm._s(item.currency ? item.currency : "¥") + " "
                      ),
                    ]),
                    _c("span", { staticClass: "columnText2" }, [_vm._v("/份")]),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "column" },
                  [
                    _c("div", { staticClass: "columnText2" }, [
                      _vm._v(" 服务备注 "),
                    ]),
                    _c("el-input", {
                      staticClass: "columnText3",
                      staticStyle: { width: "4.12rem" },
                      attrs: {
                        disabled: _vm.disabled,
                        size: "small",
                        placeholder: "请填写服务标准等描述",
                        type: "text",
                      },
                      model: {
                        value: item.containDescribe,
                        callback: function ($$v) {
                          _vm.$set(item, "containDescribe", $$v)
                        },
                        expression: "item.containDescribe",
                      },
                    }),
                  ],
                  1
                ),
              ])
            }),
          ],
          2
        ),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "column" }, [
      _c("div", { staticClass: "columnText4" }, [
        _vm._v(" 杂费是否包含在报价内 "),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "column",
        staticStyle: { "background-color": "rgba(250, 250, 250, 1)" },
      },
      [
        _c("div", { staticClass: "columnTitle" }, [
          _vm._v(" 价格内"),
          _c("span", { staticClass: "columnText4" }, [_vm._v("包含")]),
          _vm._v("的设施和服务 "),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "column",
        staticStyle: { "background-color": "rgba(250, 250, 250, 1)" },
      },
      [
        _c("div", { staticClass: "columnTitle" }, [
          _vm._v(" 价格内"),
          _c("span", { staticClass: "columnText4" }, [_vm._v("不含")]),
          _vm._v("的设施和服务 "),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }